import { render, staticRenderFns } from "./ModalDeleteBox.vue?vue&type=template&id=81029358&"
import script from "./ModalDeleteBox.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteBox.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteBox.vue?vue&type=style&index=0&id=81029358&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports